import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';

const AmountInfo = () => (
  <div className="d-flex align-items-center amount-info-wrapper">
    <FaInfoCircle size={20} />
    A positive amount increases taxable income, negative decreases taxable income.
  </div>
);

export default AmountInfo;
